import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { NavigationLinkButton, Header } from "../../components/RegularComponents";

export const BusinessNotEligible = (props) => {
  const dispatch = useDispatch();

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const backToStart = () => {
    dispatch(push(`${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_PRIVACY_NOTICE}`));
  };

  return (
    <div className="container">
      {/* Title */}

      <div className="row">
        <div className="col-lg-8">
          <Header
            id="rjsc-detail-review-header"
            header={"Your business isn't eligible for a licence in Nova Scotia"}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <p>To apply for a mortgage lender licence in Nova Scotia your company must be either:</p>
          <ul>
            <li>incorporated or continued under the laws of any jurisdiction in Canada</li>
            <li>formed under the laws of any jurisdication in Canada, if it's a partnership</li>
          </ul>
        </div>
      </div>

      {/* Back to start */}
      <div className="row">
        <div className="col-lg-2">
          <NavigationLinkButton
            style={{paddingLeft: "0px"}}
            text="Back to start"
            onClick={backToStart}

          />
        </div>
      </div>
    </div>
  );
};
